import React, { Children, useEffect, useState, useRef } from 'react'

import classes from "./CreateVirtualSource.module.css";


import Modal from '../../../../Modal/Modal';
import Button2 from '../../../Button/Button2';
import { alpha, colors } from '@mui/material';

const SelectCCTVIntegration = ({ HandleSelectCamectModalForm, firmwareMajor, firmwareMinor, supportsCamect, siteType}) => {

    const ModalDialog = useRef();

    useEffect(() => {
        console.log("mounted")
        console.log(siteType)
    }, [])

    const handleSelectCamectModalForm = (AutomationID) => {
        HandleCloseModal();
        HandleSelectCamectModalForm(AutomationID);
    }

    const [modalComponent, setModalComponent] = useState(null);
    
    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
    }

    useEffect(() => {
        setModalComponent(    
            <div className={classes.container}>
                {/* Show Camect button only if firmware version is above or equal to 1.7 and is supported (Owned by RE:SURE)*/}
                {((firmwareMajor > 1 || (firmwareMajor == 1 && firmwareMinor >= 7)) && supportsCamect == 1) && (
                    <Button2 
                        style={{ 
                            minWidth: "350px", 
                            minHeight: "50px", 
                            display: "flex", 
                            justifyContent: "center", 
                            alignItems: "center"
                        }}    
                        onClick={() => handleSelectCamectModalForm(0)}>
                        <h4 style={{margin:"0px"}}>{"Camect"}</h4>
                    </Button2>
                )}
                {/* Show Davantis button only if firmware version is equal to 3 */}
                {(firmwareMajor == 3) && (
                    <Button2 
                        style={{ 
                            minWidth: "350px", 
                            minHeight: "50px", 
                            display: "flex", 
                            justifyContent: "center", 
                            alignItems: "center"
                        }}    
                        onClick={() => handleSelectCamectModalForm(8)}>
                        <h4 style={{margin:"0px"}}>{"Davantis"}</h4>
                    </Button2>
                )}
                {(siteType == "S") && (
                         <Button2 style={{ 
                            minWidth: "350px", 
                            minHeight: "50px", 
                            display: "flex", 
                            justifyContent: "center", 
                            alignItems: "center"
                        }
                    }    onClick={() => handleSelectCamectModalForm(12)}>
                            <h4 style={{margin:"0px"}}>Ganz AiBox</h4>
                        </Button2>
                )}
                {(
                    <Button2
                        style={{ 
                            minWidth: "350px", 
                            minHeight: "50px", 
                            display: "flex", 
                            justifyContent: "center", 
                            alignItems: "center"
                        }}
                        onClick={() => handleSelectCamectModalForm(9)}>
                        <h4 style={{margin:"0px"}}>{"Hikvision"}</h4>
                    </Button2>
                )}

                    <Button2 
                        style={{
                            minWidth: "350px", 
                            minHeight: "50px", 
                            display: "flex", 
                            justifyContent: "center", 
                            alignItems: "center"
                        }}    
                        onClick={() => handleSelectCamectModalForm(14)}>
                        <h4 style={{margin:"0px"}}>{"AJAX"}</h4>
                    </Button2>

                    <Button2
                        style={{
                            minWidth: "350px", 
                            minHeight: "50px", 
                            display: "flex", 
                            justifyContent: "center", 
                            alignItems: "center"
                        }}    
                        onClick={() => handleSelectCamectModalForm(15)}>
                        <h4 style={{margin:"0px"}}>{"Dahua"}</h4>
                    </Button2>
                </div>
            )
            HandleShowModal();
        },[])
    
    return (
        <>
        <Modal ref={ModalDialog} title={"Select CCTV Integration"} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} modalLayoutStyle={{ alignItems: "center" }}>
            {modalComponent}
        </Modal>
        </>
    );
}

export default SelectCCTVIntegration;




